import Swiper, { Autoplay } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const initSwiper = () => {
  const swipers = document.querySelectorAll(".stats-carousel .swiper");

  swipers.forEach((swiperElement) => {

    const swiperInitOptions = {
      modules: [Autoplay],
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 8000,
      allowTouchMove: true,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false,
      },
    };

    if (!isAnimationStopped()) {
      swiperInitOptions.autoplay = {
        delay: 0,
      };
    }

    const swiper = new Swiper(swiperElement, swiperInitOptions);

    const playButton = swiperElement.closest(".stats").querySelector(".play");

    if (playButton) {
      playButton.addEventListener("click", () => {
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
          playButton.classList.add("active");
        } else {
          swiper.autoplay.start();
          playButton.classList.remove("active");
        }
      });
    }
  });
};

window.addEventListener("load", initSwiper);
